/**
 * _PopulateRoomId.js
 */

import $ from 'jquery';
import Utilities from './Utilities';

class PopulateRoomId {

    constructor() {

        $('[data-room-id]').on( 'click', function(e) {
            e.preventDefault();

            let roomId = $(this).data().roomId

            $('.booking-modal').addClass('active');
            $('html').addClass('locked');

            $('#modal-room-id').val( roomId );


        })


    }

}
new PopulateRoomId();
